<template>
  <div>
    <section class="contact-page">
      <div class="container">
        <div
          v-if="$route.query.needHelp"
          class="d-flex text-center align-items-center top-div"
        >
          <router-link button :to="`/need-help/${$route.query.orderNumber}`">
            <b-icon icon="arrow-left-short"></b-icon>
          </router-link>
          <h5>
            <b>{{ $route.query.needHelp }}</b>
          </h5>
        </div>
        <h3 v-else class="contactHeading font-weight-bold pt-2">
          {{ $t("contactUs.title") }}
        </h3>
      </div>
      <div class="container">
        <div class="row section-b-space">
          <div class="col-lg-7 col-md-6 col-sm-12 d-flex align-items-center">
            <div class="contact-right">
              <ul class="">
                <li>
                  <div class="row align-items-center">
                    <div class="col-md-6 col-sm-6 col-lg-4 contact-icon">
                      <img src="img/contact/phone.png" alt="Phone icon" />
                      <h6 class="font-weight-bold">
                        {{ $t("contactUs.title") }}
                      </h6>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-8">
                      <p class="contact-text">{{ storePhone }}</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="row align-items-center">
                    <div class="col-md-6 col-sm-6 col-lg-4 contact-icon">
                      <img src="img/contact/email.png" alt="Email icon" />
                      <h6 class="font-weight-bold">
                        {{ $t("contactUs.email") }}
                      </h6>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-8">
                      <p class="contact-text">{{ storeEmail }}</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="row align-items-center">
                    <div class="col-md-6 col-sm-6 col-lg-4 contact-icon">
                      <!-- house-door-fill -->
                      <b-icon
                        icon="house-door"
                        scale="1.4"
                        style="color: #ff5044"
                      ></b-icon>
                      <!-- <img src="img/contact/phone.png" alt="Address icon" /> -->
                      <h6 class="font-weight-bold">
                        {{ $t("contactUs.address") }}
                      </h6>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-8">
                      <p class="contact-text">
                        {{ storeAddress }}
                      </p>
                    </div>
                  </div>
                </li>
                <!-- <li>
									<div class="row">
										<div class="col-lg-2 contact-icon">
											<b-icon-hand-thumbs-up
												variant="danger"
											></b-icon-hand-thumbs-up>
											<h6 class="font-weight-bold">
												Follow us
											</h6>
										</div>
										<div class="col-lg-10">
											<div class="marginleft-70">
												<a
													target="_blank"
													href="https://www.facebook.com/eparishevaonline/"
												>
													<img
														src="img/footer/facebook.png"
														alt="Facebook icon"
													/>
												</a>
												<a
													target="_blank"
													href="https://www.instagram.com/eparishevawestbengal/?r=nametag"
												>
													<img
														src="img/footer/instagram.png"
														class="mx-2"
														alt="Instagram icon"
													/>
												</a>
												<a
													target="_blank"
													href="https://www.linkedin.com/company/6457757/admin/"
												>
													<img
														src="img/footer/linkedin.png"
														alt="LinkedIn icon"
													/>
												</a>
											</div>
										</div>
									</div>
								</li> -->
              </ul>
            </div>
          </div>
          <div class="col-lg-5 col-md-6 col-sm-12">
            <GmapMap
              :center="storePosition"
              :zoom="7"
              map-type-id="terrain"
              style="width: 440px; height: 300px"
            >
              <GmapMarker
                label="★"
                :draggable="true"
                :position="storePosition"
              />
            </GmapMap>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  computed: {
    ...mapState({
      storeInfo: (state) => state.home.storeInfo,
    }),
    storeEmail() {
      return this.storeInfo?.authentication?.email || "";
    },
    storePhone() {
      return this.storeInfo?.authentication?.phone || "";
    },
    storePosition() {
      const address = this.storeInfo?.office?.address || null;
      if (!address) return { lat: 0, lng: 0 };
      return {
        lat: address?.location?.coordinates[1] || 0,
        lng: address?.location?.coordinates[0] || 0,
      };
    },
    storeAddress() {
      const address = this.storeInfo?.office?.address || "";

      if (!address) {
        return "";
      }

      const parts = [
        address.street1,
        address.street2,
        address.city,
        address.state,
        address.zip,
      ].filter(Boolean); // removes empty strings or undefined/null
      return parts.join(", ");
    },
  },
};
</script>
<style scoped>
ul {
  list-style-type: none;
}

.bi-arrow-left-short {
  height: 3rem;
  width: 3rem;
  color: var(--primarycolor);
  padding: 0px;
}

.bi-arrow-left-short:hover {
  color: var(--darkcolor);
}

.contact-page .contact-right ul li .contact-icon {
  border-right: none;
  border-bottom: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
  width: 100%;
}
.contactHeading {
  text-align: center;
}
@media (min-width: 576px) {
  .contact-page .contact-right ul li .contact-icon {
    border-right: 1px solid #ddd;
    border-bottom: none;
  }
}
@media (max-width: 768px) {
  .contact-page .contact-right ul li {
    border-bottom: 1px solid #dddd;
  }
  .contact-page .contact-right ul li .contact-icon {
    border: none;
  }
}
.contact-page .contact-right ul li .contact-icon img {
  width: 20px;
  max-width: 100%;
  height: auto;
}

.contact-icon h6 {
  margin-bottom: 0;
  text-align: center;
  font-size: 0.9rem;
}

.contact-text {
  text-align: center;
  margin: 15px 0;
}

@media (min-width: 576px) {
  .contact-text {
    text-align: left;
    margin: 0;
    padding-left: 20px;
  }
}

.contact-page .contact-right ul li {
  margin: 0;
  padding: 10px 0;
}

@media (max-width: 575px) {
  .marginleft-140,
  .marginleft-150,
  .marginleft-160 {
    margin-left: 0 !important;
  }

  .top-div {
    padding: 10px;
  }
}
</style>
